module.exports = __webpack_public_path__ + "static/img/Request.d9221944.png";